// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".forgot-password-link[data-v-1caf5cda]{max-width:375px}img[data-v-1caf5cda]{width:100%}", ""]);
// Exports
module.exports = exports;
